import { render, staticRenderFns } from "./MailboxDrivers.vue?vue&type=template&id=a18676ac&"
import script from "./MailboxDrivers.vue?vue&type=script&lang=js&"
export * from "./MailboxDrivers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports